import React, { Component } from "react";
import { Dropdown, Modal, Button } from "semantic-ui-react";
import ReadAxios from "../axiosComponent/read";
import { isEmpty } from "lodash";

export class SuggestedVendor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      vendorPartnerList: [],
      selectedVendorId: null,
      selectedVendorName: null
    };
  }

  componentDidMount() {
    let partnerList = this.props.agGridReact.props.vendorPartnerList;
    this.setState({ vendorPartnerList: partnerList });
  }
  handleOpenModal = (deliveryconsigneeList) => {
    if (this.props.data?.allotment_status?.allotment_code == 'ALLOC' || this.props.data?.allotment_status?.allotment_code == 'ACK' || this.props.data?.allotment_status?.allotment_code == 'COMPLETE')
      return false
    else
      this.setState({ open: true });
  };

  dropdownSelected = (name, data) => {
    if (data.value) {
      let options = data.options
      let selectedList = options.filter((item, index) => { if (item.value == data.value) { return item; } });
      let selectedPartner = data.value
      this.setState({ selectedVendorId: selectedPartner });
      this.setState({ selectedVendorName: selectedList[0].text });
    } else {
      this.setState({ selectedVendorId: "" });
      this.setState({ selectedVendorName: "" });
    }
  }

  saveSuggestedVendor = () => {
    let orderID = this.props.data.vendor_order_id;

    this.props.agGridReact.props.resetSuggestedPartner(this.state.selectedVendorId, this.state.selectedVendorName, orderID)
    this.setState({ open: false });
  }

  render() {
    return (
      <>
        <div title={this.props.value} onClick={() => this.handleOpenModal()}>{this.props.data.suggested_vendor ? this.props.data.suggested_vendor : "-"}</div>

        <Modal
          onClose={() => this.setState({ open: false })}
          //onOpen={() => setOpen(true)}
          open={this.state.open && this.props.data.allotment_status.allotment_text === "Created" }
        //trigger={<Button>Delivery Reference Number</Button>}
        >
          <Modal.Header>Suggested Vendor</Modal.Header>
          <Modal.Content style={{ paddingBottom: '200px' }}>
            <label className="labelName mt-2">
              Suggested Vendor
            </label>
            <Dropdown
              clearable
              search
              style={{ width: "100%" }}
              selection
              placeholder="Select Suggested Vendor"
              onChange={this.dropdownSelected}
              options={this.state.vendorPartnerList}
            //defaultValue={values.vendor}
            />
          </Modal.Content>
          <Modal.Actions>
            <Button basic onClick={this.saveSuggestedVendor}>
              Save
            </Button>
            <Button basic onClick={() => this.setState({ open: false })}>
              Close
            </Button>
          </Modal.Actions>
        </Modal>
      </>
    );
  }
}

export default SuggestedVendor;
